import { render } from "./TablePlaceholder.vue?vue&type=template&id=4d11b925&ts=true"
import script from "./TablePlaceholder.vue?vue&type=script&lang=ts"
export * from "./TablePlaceholder.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__